<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li
                v-for="(entry, i) in entries"
                v-bind:key="entry.Url"
                v-bind:class="getBreadcrumbClass(i)">
                <a
                    v-if="i < entries.length - 1"
                    v-bind:href="entry.Url">
                    {{ entry.Display }}
                </a>
                <span
                    v-else
                    aria-current="page">
                    {{ entry.Display }}
                </span>
            </li>
        </ol>
    </nav>
</template>
<script>
    export default {
        props: {
            breadcrumbModel: { type: Object, required: true }
        },
        computed: {
            entries() {
                return this.breadcrumbModel == null ? [] : this.breadcrumbModel.Entries;
            }
        },
        methods: {
            getBreadcrumbClass(index) {
                if (index == this.entries.length - 1) {
                    return "breadcrumb-item active";
                }
                return "breadcrumb-item";
            }
        }
    };
</script>
